import { render, staticRenderFns } from "./changed-add-or-update.vue?vue&type=template&id=444380c6&scoped=true&"
import script from "./changed-add-or-update.vue?vue&type=script&lang=js&"
export * from "./changed-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./changed-add-or-update.vue?vue&type=style&index=0&id=444380c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444380c6",
  null
  
)

export default component.exports